import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import Terms from "./static/Terms";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const TermsPage = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header />
      <Terms />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default TermsPage;
